module.exports = __webpack_public_path__ + "static/media/PM29.15fa7025.png";